import React from 'react';
import Navbar from "./Navbar";
import Footer from "./Footer";

const About = () => {
    return (
        <>
            <Navbar />
            <div className="min-h-screen bg-white py-24">
                <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
                    <h1 className="text-4xl font-extrabold bg-gradient-to-r from-blue-600 to-blue-800 bg-clip-text text-transparent mb-8">
                        About Us
                    </h1>

                    <div className="prose prose-blue max-w-none">
                        <section className="mb-12">
                            <h2 className="text-2xl font-bold text-gray-900 mb-4">Our Mission</h2>
                            <p className="text-gray-600">
                                At RemoveBackground.online, we're dedicated to making professional-grade image editing accessible to everyone.
                                Our mission is to provide a free, efficient, and privacy-focused solution for background removal that delivers
                                exceptional results without compromising user data or requiring technical expertise.
                            </p>
                        </section>

                        <section className="mb-12">
                            <h2 className="text-2xl font-bold text-gray-900 mb-4">Technology</h2>
                            <p className="text-gray-600 mb-4">
                                Our platform leverages cutting-edge AI technology to deliver high-quality background removal:
                            </p>
                            <ul className="list-disc pl-6 text-gray-600">
                                <li>Advanced deep learning models for precise subject detection</li>
                                <li>Browser-based processing for enhanced privacy and speed</li>
                                <li>WebGPU acceleration for supported devices</li>
                                <li>Continuous model improvements and updates</li>
                            </ul>
                        </section>

                        <section className="mb-12">
                            <h2 className="text-2xl font-bold text-gray-900 mb-4">Privacy First</h2>
                            <p className="text-gray-600">
                                We believe in absolute privacy. Unlike traditional online tools, our service processes all images locally in
                                your browser. Your images never leave your device, ensuring complete confidentiality and security of your data.
                            </p>
                        </section>

                        <section className="mb-12">
                            <h2 className="text-2xl font-bold text-gray-900 mb-4">Open Source</h2>
                            <p className="text-gray-600">
                                We're proud to be part of the open-source community. Our codebase is publicly available, allowing for
                                transparency, community contributions, and continuous improvement through collaboration.
                            </p>
                        </section>

                        <section className="mb-12">
                            <h2 className="text-2xl font-bold text-gray-900 mb-4">Contact Us</h2>
                            <p className="text-gray-600">
                                Have questions or suggestions? We'd love to hear from you! Reach out to us at:{' '}
                                <a href="mailto:contact@removebackground.online" className="text-blue-600 hover:text-blue-500">
                                    contact@removebackground.online
                                </a>
                            </p>
                        </section>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    );
};

export default About;